import { DataEntry, MetadataCard } from '@common/components/MetadataCard';
import { useSelectedCollectionMetadata } from '@features/Collection/hooks';
import { Theme } from '@radix-ui/themes';
import { useTranslation } from 'react-i18next';

export const GlobalInfoSection = () => {
    const { t } = useTranslation('collectionDetails');
    const { data: metadata, isLoading } = useSelectedCollectionMetadata();

    const displayOrder = [
        'title',
        'proscopeId',
        'releaseDate',
        'genres',
        'duration',
        'productionCountry',
    ] as const;

    const translatedMetadataObject = displayOrder.reduce((acc, key) => {
        const rawValue = metadata[key];
        const value = Array.isArray(rawValue) ? rawValue.join(', ') : rawValue;
        acc.push({ label: t(`metadata.${key}`), value });
        return acc;
    }, [] as DataEntry[]);

    return (
        <Theme radius='none'>
            <MetadataCard
                title={t('globalInformation')}
                data={translatedMetadataObject}
                columns={2}
                rows={3}
                isLoading={isLoading}
            />
        </Theme>
    );
};
